import { createContext } from 'react';

const GameContext = createContext<undefined | GameContext>(undefined);

export default GameContext;
